import { createFileRoute } from '@tanstack/react-router';

import { Dashboard } from '@features/dashboard';

export const Route = createFileRoute('/$venueSlug/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Dashboard />;
}
